import React, { Component } from 'react'
import './mediaBrowse.css'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

class MediaBrowse extends Component {

    static propTypes = {
        currentPosition: PropTypes.number.isRequired,
        count: PropTypes.number.isRequired,
        hasPrevious: PropTypes.bool.isRequired,
        hasNext: PropTypes.bool.isRequired,
        isNavigationEnabled: PropTypes.bool.isRequired,
        jumpStep: PropTypes.number.isRequired,
        isFastNavigationEnabled: PropTypes.bool.isRequired,
        onPrevious: PropTypes.func.isRequired,
        onNext: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        onBackward: PropTypes.func.isRequired,
        onForward: PropTypes.func.isRequired,
        onFirstMedia: PropTypes.func.isRequired,
        onLastMedia: PropTypes.func.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.setInputRef = this.setInputRef.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onKeyPress = this.onKeyPress.bind(this)
        this.onClick = this.onClick.bind(this)
    }

    setInputRef(ref)
    {
        if(! ref)
        {
            return
        }

        this.inputRef = ref
    }

    onChange()
    {
        let userInput = Number(this.inputRef.value)
        if(! Number.isInteger(userInput))
        {
            userInput = this.props.currentPosition
        }
        this.props.onChange(userInput)
    }

    onKeyPress(event)
    {
        if(event.key === 'Enter')
        {
            this.onChange()
        }
    }

    onClick(event)
    {
        event.target.setSelectionRange(0, event.target.value.length)
    }

    componentWillUpdate(nextProps)
    {
        this.inputRef.value = nextProps.currentPosition
    }

    render()
    {
        const {
            currentPosition,
            count,
            onNext,
            onPrevious,
            isNavigationEnabled,
            hasPrevious,
            hasNext,
            jumpStep,
            onBackward,
            onForward,
            onFirstMedia,
            onLastMedia,
            isFastNavigationEnabled,
            t,
        } = this.props

        return (
            <div className='media-browse'>
                <button onClick={onFirstMedia} className={classNames({'disabled': ! hasPrevious}, 'fa fa-fast-backward', 'backward')} title={t('visualizer:pagination.first')} />
                <button onClick={onBackward} className={classNames({'disabled': ! hasPrevious || ! isFastNavigationEnabled}, 'fa fa-angle-double-left')} title={`- ${jumpStep}`} />
                <button onClick={onPrevious} className={classNames({'disabled': ! hasPrevious}, 'fa fa-angle-left')} title={t('visualizer:pagination.previous')} />
                <div className="pagination-form">
                    <label>{t('visualizer:type.media')}</label>
                    <input ref={this.setInputRef} disabled={ isNavigationEnabled ? '' : 'disabled' } onClick={this.onClick} onBlur={this.onChange} type="text" onKeyDown={this.onKeyPress} defaultValue={currentPosition} />
                    <span className={'page-count'}>/ {count}</span>
                </div>
                <button onClick={onNext} className={classNames({'disabled': ! hasNext}, 'fa fa-angle-right')} title={t('visualizer:pagination.next')} />
                <button onClick={onForward} className={classNames({'disabled': ! hasNext || ! isFastNavigationEnabled}, 'fa fa-angle-double-right')} title={`+ ${jumpStep}`} />
                <button onClick={onLastMedia} className={classNames({'disabled': ! hasNext}, 'fa fa-fast-forward', 'forward')} title={t('visualizer:pagination.last')} />
            </div>
        )
    }
}

export default withTranslation()(MediaBrowse)
